// removed by extract-text-webpack-plugin
module.exports = {"container":"logo-module-container-fabb0cc61b742efae75388178357b939--"};


//////////////////
// WEBPACK FOOTER
// /src/components/UiComponents/Logo/logo.module.scss
// module id = 1721
// module chunks = 0